var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("支付页")]),_c('p',[_vm._v("选择支付方式：")]),_c('button',[_vm._v("微信支付")]),_c('button',[_vm._v("支付宝支付")])])
}]

export { render, staticRenderFns }